export const linkPageScroll = () => {
    window.scrollTo({ top: 0 });
  };